const confettiPieces = [
  { x: -20, d: 0.1, s: 1.1, r: 200, color: '#0df20d', duration: 3.2, delay: 0, shape: 'rect' },
  { x: 20, d: 0.2, s: 0.9, r: -300, color: '#6EE7B7', duration: 3.8, delay: 0.1, shape: 'circle' },
  { x: -40, d: 0.3, s: 1, r: 400, color: '#FCD34D', duration: 3.5, delay: 0.2, shape: 'rect' },
  { x: 40, d: 0.4, s: 1.2, r: -500, color: '#93C5FD', duration: 4.1, delay: 0.05, shape: 'square' },
  { x: -10, d: 0.5, s: 0.8, r: 150, color: '#374151', duration: 4.5, delay: 0.3, shape: 'circle' },
  { x: 30, d: 0.6, s: 1.3, r: -250, color: '#0df20d', duration: 3.3, delay: 0.15, shape: 'square' },
  { x: -30, d: 0.7, s: 0.9, r: 350, color: '#6EE7B7', duration: 3.9, delay: 0.25, shape: 'rect' },
  { x: 10, d: 0.8, s: 1.1, r: -450, color: '#FCD34D', duration: 4.2, delay: 0.1, shape: 'circle' },
  { x: -50, d: 0.9, s: 1, r: 550, color: '#93C5FD', duration: 3.6, delay: 0.35, shape: 'rect' },
  { x: 50, d: 1.0, s: 1.2, r: -650, color: '#374151', duration: 4.0, delay: 0.2, shape: 'circle' },
  { x: -25, d: 0.15, s: 1.0, r: 220, color: '#0df20d', duration: 3.4, delay: 0.08, shape: 'square' },
  { x: 25, d: 0.25, s: 0.8, r: -320, color: '#6EE7B7', duration: 4.3, delay: 0.18, shape: 'circle' },
  { x: -45, d: 0.35, s: 1.1, r: 420, color: '#FCD34D', duration: 3.7, delay: 0.28, shape: 'rect' },
  { x: 45, d: 0.45, s: 0.9, r: -520, color: '#93C5FD', duration: 4.4, delay: 0.12, shape: 'circle' },
  { x: -15, d: 0.55, s: 1.2, r: 170, color: '#374151', duration: 3.9, delay: 0.22, shape: 'rect' },
  { x: 35, d: 0.65, s: 1.0, r: -270, color: '#0df20d', duration: 3.1, delay: 0.0, shape: 'square' },
  { x: -35, d: 0.75, s: 0.8, r: 370, color: '#6EE7B7', duration: 4.6, delay: 0.3, shape: 'circle' },
  { x: 15, d: 0.85, s: 1.1, r: -470, color: '#FCD34D', duration: 3.8, delay: 0.15, shape: 'rect' },
  { x: -5, d: 0.95, s: 0.9, r: 570, color: '#93C5FD', duration: 4.7, delay: 0.35, shape: 'circle' },
  { x: 5, d: 1.05, s: 1.2, r: -670, color: '#374151', duration: 4.0, delay: 0.25, shape: 'square' },
];

const getShapeClasses = (shape: string) => {
  switch (shape) {
    case 'circle':
      return 'h-2 w-2 rounded-full';
    case 'square':
      return 'h-3 w-3';
    case 'rect':
      return 'h-3 w-2 -skew-x-12';
    default:
      return 'h-2.5 w-2.5';
  }
};

export function ConfettiAnimation() {
  return (
    <div className="confetti-container z-50">
      {confettiPieces.map((piece, index) => (
        <div
          key={index}
          className="confetti"
          style={
            {
              '--x': piece.x,
              '--d': piece.d,
              '--s': piece.s,
              '--r': piece.r,
              '--c': piece.color,
              animationDuration: `${piece.duration}s`,
              animationDelay: `${piece.delay}s`,
            } as React.CSSProperties
          }
        >
          <div
            className={getShapeClasses(piece.shape)}
            style={{ backgroundColor: piece.color }}
          ></div>
        </div>
      ))}
    </div>
  );
}
